export default __webpack_public_path__ + "static/media/down_arrow.e6eca538.png";